;( function( $, undefined )
{

    $.fn.SiteCatalystUserProfile = function( siteCat )
    {
        var that = siteCat;

        var trackAddRemoveContact = function()
        {
            $( '.delete-friend-link' ).on( 'click', function()
            {
                that.track( 'Remove contact', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:remove contact:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );

            $( '.add-friend-link' ).on( 'click', function()
            {
                that.track( 'Add contact', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:add contact:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        trackAddRemoveContact();
    };

} )( jQuery );